import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ResourceEditAddFieldsModule } from '®app/resource/edit/add-fields/resource-edit-add-fields.module';
import { BibliographicResourceService } from '®shared/bibliographic-resource';

import { ResourceEditFormModule } from './resource-edit-form.module';
import { ResourceEditSmartComponent } from './resource-edit-smart.component';
import { ResourceEditComponent } from './resource-edit.component';

@NgModule({
  imports: [CommonModule, ResourceEditAddFieldsModule, ResourceEditFormModule],
  declarations: [ResourceEditSmartComponent, ResourceEditComponent],
  exports: [ResourceEditComponent],
  providers: [BibliographicResourceService],
})
export class ResourceEditModule {}
